<template>
  <v-container style="height: 100vh; max-height: 100vh;" class="pa-0 private-background" fluid>
    <v-card :style="$vuetify.breakpoint.mobile?'top:10vh':'top:25vh; max-width: 60vw'" class="ml-2 ml-sm-5" flat color="transparent">
      <v-card-title>
        <h1 class="text-uppercase">La sexpérimentation partagée</h1>
      </v-card-title>
      <v-card-text>
        <h2 class="mb-6 mt-6">Tout le monde a sa place dans Private-Games</h2>
        <p>Private-Games est une application qui ne demande aucun engagement financier de la part des couples qui l’utilisent, ce qui, en plus
          d’être inclusive, la rend réellement accessible pour tous.</p>
        <p>L’app permet aussi à chacun de créer ses propres défis afin de partager ses propres expériences aux autres,
          toujours dans le respect de la vie privée : accessible mais pas « open bar ».</p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Shared"
}
</script>

<style scoped lang="scss">
h1 {
  font-family: "Nunito";
  font-weight: bolder;
  @media (max-width: 758px) {
    font-size: 1.5em;
  }
}

.private-background {
  background-image: url("~@/assets/background/background-pg-xl-white.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: #f9e6df;
  height: calc(100vh - 128px);
  width: 100vw;
  min-width: 100vw;
  @media (max-width: 768px) {
    background-image: url("~@/assets/background/background-pg-portrait-xl-white.jpg");
  }
}
</style>